import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Tab, TabList, TabPanel, Tabs } from "react-tabs";
// import axios from "../../API/axios";
import { Button, Modal, Row } from "react-bootstrap";
import { ShimmerDiv } from "shimmer-effects-react";
import error from "../../assets/images/No-File-small.png";
import CompanyImg from "../../assets/images/khoj-images/image 484.png";
import Sidebar from "../../components/jobs/Sidebar";
import { useDispatch, useSelector } from "react-redux";
import { fetchCityData, selectCity } from "../../redux/actions/citiesAction";
import { fetchJobType, selectJobType } from "../../redux/actions/jobTypeAction";
import {
  fetchWorkLevelTypeData,
  selectWorkLevel,
} from "../../redux/actions/workLevelTypeAction";
import {
  fetchWorkLocationTypeData,
  selectWorkLocation,
} from "../../redux/actions/workLLocationTypeAction";
import {
  fetchDesignation,
  selectDesignation,
} from "../../redux/actions/designationAction";
import {
  fetchSalaryType,
  selectSalaryType,
} from "../../redux/actions/salaryTypeAction";
import {
  fetchCompanyData,
  selectGetCompanies,
} from "../../redux/actions/getCompaniesAction";
// import toast from "react-hot-toast";
import axios, { PublicKey } from "../../API/axios";
import toast from "react-hot-toast";
import ApplyJob from "./ApplyJob";
import Bookmark from "./Bookmark";

const Alljobs = ({
  // setSearchjobName,
  // searchjobName,
  jobList,
  setjobList,
  jobId,
}) => {
  const token = localStorage.getItem("token");
  console.log("jobList", jobList);

  // ...............................All Job List .......................................
  const [loading, setLoading] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [page, setPage] = useState(0);
  const [totalPages, setTotalPages] = useState(0);
  // const [jobList, setjobList] = useState([]);
  const [searchjobList, setSearchjobList] = useState([]);
  console.log("searchjobList", searchjobList);

  const [isError, setIsError] = useState(false);
  const [nextBatchLoading, setNextBatchLoading] = useState("");
  const navigate = useNavigate();

  const handleInfiniteScroll = async () => {
    try {
      if (
        window.innerHeight + document.documentElement.scrollTop + 1 >=
        document.documentElement.scrollHeight
      ) {
        setLoading(true);
        console.log("log", page, totalPages);

        page < totalPages && setPage((prev) => prev + 1);
      }
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    window.addEventListener("scroll", handleInfiniteScroll);
    return () => window.removeEventListener("scroll", handleInfiniteScroll);
  }, []);

  // .....................................................................................

  // ...............................Company Dropdown.......................................
  const dispatch = useDispatch();
  const [companyList, setCompanyList] = useState(null);
  const { getcompaniesList, selectedcompaniesId } = useSelector(
    (state) => state.getcompanies
  );
  useEffect(() => {
    dispatch(fetchCompanyData());
  }, [dispatch]);
  const handleCompany = (selectedOption) => {
    console.log("selectedOption", selectedOption);

    if (selectedOption === null) {
      setCompanyList(null);
    } else {
      setCompanyList(selectedOption.value);
    }
  };
  console.log("companyList", companyList);

  // ...............................company Dropdown.......................................

  // ...............................City DDL.......................................

  const [searchNew, setSearchNew] = useState("");
  const [cityId, setcityId] = useState(null);

  const { cityList, selectedcityId } = useSelector((state) => state.cities);
  useEffect(() => {
    dispatch(fetchCityData());
  }, [dispatch]);
  const handleCitySelect = (selectedOption) => {
    if (selectedOption === null) {
      setcityId(null);
    } else {
      setcityId(selectedOption.value);
    }
  };

  // ...............................City DDL.......................................
  // ...............................Job Type Dropdown.......................................
  const [jobType, setJobType] = useState(null);
  const { jobTypeList, selectedJobTypeId } = useSelector(
    (state) => state.jobType
  );

  useEffect(() => {
    dispatch(fetchJobType());
  }, [dispatch]);

  const handleJobType = (selectedOption) => {
    if (selectedOption === null) {
      // dispatch(selectJobType(null));
      setJobType(null);
    } else {
      // dispatch(selectJobType(selectedOption.value));
      setJobType(selectedOption.value);
    }
  };
  // ...............................Job Type Dropdown.......................................
  // ...............................Work Level Dropdown.......................................

  const { workLevelList, selectedworkLevelId } = useSelector(
    (state) => state.workLevelType
  );
  const [workLevelId, setWorkLevelId] = useState(null);
  useEffect(() => {
    dispatch(fetchWorkLevelTypeData());
  }, [dispatch]);

  const handleWorkLevel = (selectedOption) => {
    if (selectedOption === null) {
      // dispatch(selectWorkLevel(null));
      setWorkLevelId(null);
    } else {
      setWorkLevelId(selectedOption.value);
      // dispatch(selectWorkLevel(selectedOption.value));
    }
  };

  // ...............................Work Level Dropdown.......................................
  // ...............................Location Dropdown.......................................

  const [workLocationId, setWorkLocationId] = useState(null);

  const { workLocation, selectedCategoryId } = useSelector(
    (state) => state.workLocationType
  );

  useEffect(() => {
    dispatch(fetchWorkLocationTypeData());
  }, [dispatch]);

  const handleWorkLoc = (selectedOption) => {
    if (selectedOption === null) {
      // dispatch(selectWorkLocation(null));
      setWorkLocationId(null);
    } else {
      setWorkLocationId(selectedOption.value);
      // dispatch(selectWorkLocation(selectedOption.value));
    }
  };
  // ...............................Location Dropdown.......................................

  // ...............................Designation Dropdown.......................................
  const { designationList, selectedDesignationId } = useSelector(
    (state) => state.designation
  );
  const [designationId, setDesignationId] = useState(null);
  useEffect(() => {
    dispatch(fetchDesignation());
  }, [dispatch]);

  const handleDesignation = (selectedOption) => {
    if (selectedOption === null) {
      // dispatch(selectDesignation(null));
      setDesignationId(null);
    } else {
      setDesignationId(selectedOption.value);
      // dispatch(selectDesignation(selectedOption.value));
    }
  };
  // ...............................Designation Dropdown.......................................

  // ...............................Salary Dropdown.......................................
  const { salaryTypeList, selectedSalaryTypeId } = useSelector(
    (state) => state.salaryType
  );
  const [salaryId, setSalaryId] = useState(null);
  useEffect(() => {
    dispatch(fetchSalaryType());
  }, [dispatch]);
  const handleSalaryType = (selectedOption) => {
    if (selectedOption === null) {
      // dispatch(selectSalaryType(null));
      setSalaryId(null);
    } else {
      setSalaryId(selectedOption.value);
      // dispatch(selectSalaryType(selectedOption.value));
    }
  };
  // ...............................Salary Dropdown.......................................
  const getAlljobList = (page) => {
    setNextBatchLoading(true);
    const data = {
      pageNumber: page,
      pageSize: 20,
      search: searchNew,
      compId: companyList,
      cityId: cityId,
      jbTypId: jobType,
      workLevelType: workLevelId,
      workLocationTypeId: workLocationId,
      designationId: designationId,
      salaryTypeId: salaryId,
    };
    // console.log("getAllJobs", data);

    axios
      .post(`/Job/GetAll`, data)
      .then((response) => {
        const res = response.data.responseData.jobsList;
        console.log("getAlljobList", response.data.responseData.jobsList);
        setjobList(res);
        setIsLoading(false);
        setTotalPages(response.data.responseData.paging.totalPages);

        const newPosts = response.data.responseData.jobsList;
        if (searchNew !== "") {
          setjobList([]);
          setSearchjobList(newPosts);
        } else {
          setSearchjobList([]);
          setjobList((prev) => {
            const jobSet = new Set(prev?.map((job) => job?.uid));
            const uniqueNewPosts = newPosts.filter(
              (job) => !jobSet.has(job?.uid)
            );
            return [...prev, ...uniqueNewPosts];
          });
        }
      })
      .catch((error) => {
        if (error.response && error.response.status === 404) {
          setIsError(true);
        } else {
          console.log(error);
        }
        setIsLoading(false);
        setNextBatchLoading(false);
      });
  };

  //   useEffect(() => {
  //     if (page <= totalPages) {
  //       getAlljobList(page + 1);
  //     }
  //   }, [page]);

  const updateURL = () => {
    const params = new URLSearchParams();

    if (searchNew) params.append("search", searchNew);
    if (companyList) params.append("compId", companyList);
    if (cityId) params.append("cityId", cityId);
    if (jobType) params.append("jbTypId", jobType);
    if (workLevelId) params.append("workLevelType", workLevelId);
    if (workLocationId) params.append("workLocationTypeId", workLocationId);
    if (designationId) params.append("designationId", designationId);
    if (salaryId) params.append("salaryTypeId", salaryId);

    navigate(`/SearchJobs?${params.toString()}`);
  };

  useEffect(() => {
    setjobList([]); // Reset job list when searchjobName changes
    getAlljobList(1, searchNew); // Start from page 1 for a new search
    updateURL(); // Update URL with the current filter values
  }, [
    searchNew,
    companyList,
    cityId,
    jobType,
    workLevelId,
    workLocationId,
    designationId,
    salaryId,
  ]);
  // ...............................All Jobs List.......................................
  return (
    <>
      <section className="inner-employer-section PeopleSearch pt-5">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="group-4-8  Search-Job-Cards">
                <div className="cl4 sidebar">
                  <Sidebar
                    cityList={cityList}
                    cityId={cityId}
                    handleCitySelect={handleCitySelect}
                    getcompaniesList={getcompaniesList}
                    selectedcompaniesId={companyList}
                    handleCompany={handleCompany}
                    jobTypeList={jobTypeList}
                    selectedJobTypeId={jobType}
                    handleJobType={handleJobType}
                    workLevelList={workLevelList}
                    selectedworkLevelId={workLevelId}
                    handleWorkLevel={handleWorkLevel}
                    workLocation={workLocation}
                    selectedCategoryId={workLocationId}
                    handleWorkLoc={handleWorkLoc}
                    designationList={designationList}
                    selectedDesignationId={designationId}
                    handleDesignation={handleDesignation}
                    salaryTypeList={salaryTypeList}
                    selectedSalaryTypeId={salaryId}
                    handleSalaryType={handleSalaryType}
                    setSearchNew={setSearchNew}
                    searchNew={searchNew}
                  />
                </div>
                <Tabs className="cl8 tf-tab jobcontent ">
                  <Row>
                    <div className="container ">
                      <div className=" content-tab">
                        <TabPanel
                          className="inner"
                          style={{
                            minHeight:
                              isLoading || nextBatchLoading ? "600px" : "auto",
                            height: "auto",
                          }}
                        >
                          <div className="group-col-3 Search-job-group">
                            {isLoading ? (
                              <div className="row mt-2">
                                <div className=" ">
                                  <ShimmerDiv
                                    mode="light"
                                    height={400}
                                    width={"100%"}
                                  />
                                </div>
                                <div className="col-md-6">
                                  <ShimmerDiv
                                    mode="light"
                                    height={400}
                                    width={"100%"}
                                  />
                                </div>
                                <div className="col-md-6 mt-2">
                                  <ShimmerDiv
                                    mode="light"
                                    height={400}
                                    width={"100%"}
                                  />
                                </div>
                                <div className="col-md-6 mt-2">
                                  <ShimmerDiv
                                    mode="light"
                                    height={400}
                                    width={"100%"}
                                  />
                                </div>
                                <div className="col-md-6 mt-2">
                                  <ShimmerDiv
                                    mode="light"
                                    height={400}
                                    width={"100%"}
                                  />
                                </div>
                                <div className="col-md-6 mt-2">
                                  <ShimmerDiv
                                    mode="light"
                                    height={400}
                                    width={"100%"}
                                  />
                                </div>
                              </div>
                            ) : isError ||
                              (jobList.length === 0 &&
                                searchjobList.length === 0) ? (
                              <div className="mt-2 error-image-cont error-cont m-auto">
                                <img
                                  src={error}
                                  alt="404 Not Found"
                                  width={300}
                                />
                              </div>
                            ) : searchjobList.length === 0 ? (
                              jobList &&
                              jobList?.map((idx, index) => {
                                return (
                                  <div
                                    key={idx.id}
                                    className="col-lg-6 col-md-6 p-2"
                                  >
                                    <div className="features-job Serach-features-job">
                                      <div className="job-archive-header">
                                        <div className="inner-box">
                                          <div className="logo-company">
                                            <img
                                              src={idx.compImage}
                                              alt="jobtex"
                                            />
                                          </div>
                                          <div className="box-content Inner-box-content">
                                            <div className="d-flex justify-content-between align-items-center">
                                              <h4 className="mb-0">
                                                {token === null ? (
                                                  idx.compName
                                                ) : (
                                                  <Link
                                                    to={`/jobDetails/${idx.jobId}`}
                                                  >
                                                    {idx.compName}
                                                  </Link>
                                                )}
                                              </h4>
                                              <div>
                                                <Bookmark
                                                  jobId={idx.jobId}
                                                  issavedbyyou={idx.isSaved}
                                                  className="m-0"
                                                />
                                              </div>
                                            </div>

                                            <h3>
                                              {token === null ? (
                                                idx.title
                                              ) : (
                                                <Link
                                                  to={`/jobDetails/${idx.jobId}`}
                                                >
                                                  {idx.title}
                                                </Link>
                                              )}
                                            </h3>
                                            <ul className="mt-0 ps-0">
                                              <li>
                                                <span className="icon-map-pin me-1"></span>
                                                {idx.cityName}
                                              </li>
                                            </ul>
                                          </div>
                                        </div>
                                      </div>
                                      <div className="job-archive-footer">
                                        <div className="job-footer-left ">
                                          <ul className="job-tag Job-Footer-Small-Button">
                                            <li className="Card-Item-Type-Content">
                                              <Link to="#">
                                                {idx.jbTypName}
                                              </Link>
                                            </li>
                                            <li className="Card-Item-Type-Content">
                                              <Link to="#">
                                                {idx.workLevelTypename}
                                              </Link>
                                            </li>
                                            <li className="Card-Item-Type-Content">
                                              <Link to="#">
                                                {idx.workLocationTypeName}
                                              </Link>
                                            </li>
                                            <li className="Card-Item-Type-Content">
                                              <Link to="#">
                                                {idx.designationName}
                                              </Link>
                                            </li>
                                          </ul>
                                        </div>
                                        <div className="job-footer-right">
                                          <div className="price">
                                            <span className="">
                                              {idx.currency}
                                            </span>
                                            <p className="mb-0 ms-2">
                                              {idx.maxSalary}
                                              <span className="year">
                                                /{idx.salaryTypeName}
                                              </span>
                                            </p>
                                          </div>
                                          <p className="days mb-0">
                                            {idx.apply}
                                          </p>

                                          <div>
                                            <ApplyJob
                                              jobId={idx.jobId}
                                              isAppliedByYou={idx.isApplied}
                                              instituteAppliedJobsInfo={
                                                idx.instituteAppliedJobsInfo
                                              }
                                              getAlljobList={getAlljobList}
                                            />
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                );
                              })
                            ) : (
                              searchjobList &&
                              searchjobList?.map((idx, index) => {
                                return (
                                  <div
                                    key={idx.id}
                                    className="col-lg-6 col-md-6 p-2"
                                  >
                                    <div className="features-job Serach-features-job">
                                      <div className="job-archive-header">
                                        <div className="inner-box">
                                          <div className="logo-company">
                                            <img
                                              src={idx.compImage}
                                              alt="jobtex"
                                            />
                                          </div>
                                          <div className="box-content Inner-box-content">
                                            <div className="d-flex justify-content-between align-items-center">
                                              <h4 className="mb-0">
                                                {token === null ? (
                                                  idx.compName
                                                ) : (
                                                  <Link
                                                    to={`/jobDetails/${idx.jobId}`}
                                                  >
                                                    {idx.compName}
                                                  </Link>
                                                )}
                                              </h4>
                                              <div>
                                                <Bookmark
                                                  jobId={idx.jobId}
                                                  issavedbyyou={idx.isSaved}
                                                  className="m-0"
                                                />
                                              </div>
                                            </div>

                                            <h3>
                                              {token === null ? (
                                                idx.title
                                              ) : (
                                                <Link
                                                  to={`/jobDetails/${idx.jobId}`}
                                                >
                                                  {idx.title}
                                                </Link>
                                              )}
                                            </h3>
                                            <ul className="mt-0 ps-0">
                                              <li>
                                                <span className="icon-map-pin me-1"></span>
                                                {idx.cityName}
                                              </li>
                                            </ul>
                                          </div>
                                        </div>
                                      </div>
                                      <div className="job-archive-footer">
                                        <div className="job-footer-left ">
                                          <ul className="job-tag Job-Footer-Small-Button">
                                            <li className="Card-Item-Type-Content">
                                              <Link to="#">
                                                {idx.jbTypName}
                                              </Link>
                                            </li>
                                            <li className="Card-Item-Type-Content">
                                              <Link to="#">
                                                {idx.workLevelTypename}
                                              </Link>
                                            </li>
                                            <li className="Card-Item-Type-Content">
                                              <Link to="#">
                                                {idx.workLocationTypeName}
                                              </Link>
                                            </li>
                                            <li className="Card-Item-Type-Content">
                                              <Link to="#">
                                                {idx.designationName}
                                              </Link>
                                            </li>
                                          </ul>
                                        </div>
                                        <div className="job-footer-right">
                                          <div className="price">
                                            <span className="">
                                              {idx.currency}
                                            </span>
                                            <p className="mb-0 ms-2">
                                              {idx.maxSalary}
                                              <span className="year">
                                                /{idx.salaryTypeName}
                                              </span>
                                            </p>
                                          </div>
                                          <p className="days mb-0">
                                            {idx.apply}
                                          </p>

                                          <div>
                                            <ApplyJob
                                              jobId={idx.jobId}
                                              isAppliedByYou={idx.isApplied}
                                              instituteAppliedJobsInfo={
                                                idx.instituteAppliedJobsInfo
                                              }
                                              getAlljobList={getAlljobList}
                                            />
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                );
                              })
                            )}
                          </div>
                        </TabPanel>
                      </div>
                    </div>
                  </Row>
                </Tabs>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Alljobs;
